import { render, staticRenderFns } from "./CommissionPaymentsEdit.vue?vue&type=template&id=281e046b&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform&"
import script from "./CommissionPaymentsEdit.vue?vue&type=script&lang=js&"
export * from "./CommissionPaymentsEdit.vue?vue&type=script&lang=js&"
import style0 from "./CommissionPaymentsEdit.vue?vue&type=style&index=0&id=281e046b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "281e046b",
  null
  
)

export default component.exports